import React, { useState } from "react";
import Styles from "../../assets/scss/HelpCenterNormalUser/HelpCenterUserForm.module.scss";
import Select from "react-select";
import { useGetEnquiryIssuesQuery, useCreateEnquiryMutation } from "../../slices/admin/admin";
import { toast } from "react-toastify";
import { getUserInfo } from "../../utils/user.util";
import { FaTimes, FaCheck } from "react-icons/fa";

const HelpCenterUserForm = ({ onClose, onSuccess }) => {

    const localUser = getUserInfo();
    const userId = localUser?._id;

    const { data, isLoading } = useGetEnquiryIssuesQuery();
    const issues = data?.data || [];

    const [createEnquiry, { isLoading: isSubmitting }] =
        useCreateEnquiryMutation();

    // 🔥 Store full selected object instead of only ID
    const [issueType, setIssueType] = useState(null);
    const [description, setDescription] = useState("");
    const [errors, setErrors] = useState({});

    const issueOptions = issues.map((issue) => ({
        value: issue._id,
        label: issue.issueName,
    }));

    const selectStyles = {
        control: (base, state) => ({
            ...base,
            minHeight: "45px",
            height: "45px",
            boxShadow: "none",
            borderColor: state.isFocused ? "#548731" : "#dcdcdc",
            fontFamily: "'Poppins', sans-serif",
        }),
        menu: (base) => ({
            ...base,
            zIndex: 9999,
            fontFamily: "'Poppins', sans-serif",
        }),
        option: (base, state) => ({
            ...base,
            fontFamily: "'Poppins', sans-serif",
            backgroundColor: state.isFocused ? "#f5f5f5" : "white",
            color: "#333",
        }),
        singleValue: (base) => ({
            ...base,
            fontFamily: "'Poppins', sans-serif",
        }),
        placeholder: (base) => ({
            ...base,
            fontFamily: "'Poppins', sans-serif",
            color: "#999",
        }),
    };

    const handleSubmit = async () => {
        let newErrors = {};

        if (!issueType) newErrors.issueType = "Please select issue";
        if (!description.trim())
            newErrors.description = "Please enter description";

        setErrors(newErrors);

        if (Object.keys(newErrors).length === 0) {
            const payload = {
                comments: description,
                queries: [issueType?.label], // ✅ Sending ISSUE NAME
                userId: userId,
                modeOfContact: "online",
            };

            try {
                const res = await createEnquiry(payload).unwrap();

                toast.success(res?.message || "Enquiry created successfully");

                // Reset
                setIssueType(null);
                setDescription("");
                setErrors({});

                if (onSuccess) onSuccess();
                if (onClose) onClose();

            } catch (err) {
                toast.error(err?.data?.message || "Failed to create enquiry");
            }
        }
    };

    return (
        <div className={Styles.popupOverlay}>
            <div className={Styles.popupContainer}>

                {/* HEADER */}
                <div className={Styles.header}>
                    <h2 className={Styles.tittle}>Create Ticket</h2>
                    <button className={Styles.closeIcons} onClick={onClose}>
                        <FaTimes />
                    </button>
                </div>

                <div className={Styles.padd}>

                    {/* ISSUE TYPE */}
                    <div className={Styles.inputGroup}>
                        <label className={Styles.inputLabel}>Issue Type *</label>

                        <Select
                            options={issueOptions}
                            isLoading={isLoading}
                            value={issueType}
                            onChange={(selected) => {
                                setIssueType(selected || null);
                            }}
                            placeholder="Search & Select Issue"
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            styles={{
                                ...selectStyles,
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            }}
                            formatOptionLabel={(option, { context }) => {
                                if (context === "menu") {
                                    return (
                                        <div className={Styles.optionRow}>
                                            <span>{option.label}</span>
                                            {issueType?.value === option.value && (
                                                <FaCheck className={Styles.tickIcon} />
                                            )}
                                        </div>
                                    );
                                }
                                return option.label;
                            }}
                        />

                        {errors.issueType && (
                            <span className={Styles.error}>{errors.issueType}</span>
                        )}
                    </div>

                    {/* DESCRIPTION */}
                    <div className={Styles.inputGroup}>
                        <label className={Styles.inputLabel}>Description *</label>
                        <textarea
                            value={description}
                            placeholder="Enter your issue description..."
                            onChange={(e) => setDescription(e.target.value)}
                            rows={4}
                        />
                        {errors.description && (
                            <span className={Styles.error}>{errors.description}</span>
                        )}
                    </div>

                    {/* FOOTER BUTTONS */}
                    <div className={Styles.footerButtons}>
                        <button className={Styles.cancel} onClick={onClose}>
                            Cancel
                        </button>
                        <button
                            className={Styles.save}
                            onClick={handleSubmit}
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? "Submitting..." : "Add"}
                        </button>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default HelpCenterUserForm;
